import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path d="M13 4H11V20H13V4Z" xmlns="http://www.w3.org/2000/svg" />,
  "LineL"
);
